import React, { useState } from 'react';
import TextBody, { TextBadge } from '../../../../components/controls/Typography/TextBody';

import './ProgramList.less';

/**
 * @param {import('../../../../store/reducers/dashboardReducer').TEvaluationRequest['programNames']} programNames
 * @returns {[string, string][]}
 */
const getOrgProgKeyPairs = programNames => {
  return Object.entries(programNames).sort(([organizationA], [organizationB]) =>
    organizationA.localeCompare(organizationB)
  );
};

/**
 *
 * @param {{
 *  programNames: import('../../../../store/reducers/dashboardReducer').TEvaluationRequest['programNames'];
 *  highlightWords?: string[];
 * }} props
 * @returns {React.ReactElement|null}
 */
export const ProgramList = props => {
  const { highlightWords = [] } = props;
  const [isShowMore, setIsShowMore] = useState(false);
  const orgProgs = getOrgProgKeyPairs(props.programNames) ?? [];

  /**
   *
   * @param {import('react').SyntheticEvent} event
   */
  const handleShowMore = event => {
    event.preventDefault();
    setIsShowMore(!isShowMore);
  };

  /**
   *
   * @param {?string=} str
   * @param {?string[]=} words
   * @returns
   */
  const getHighlightedStr = (str, words) => {
    let htxt = str ?? '';
    for (const word of words ?? []) {
      htxt = htxt.replaceAll(new RegExp(word.replace(/<|>/g, ''), 'gi'), `<u class='found-word bg-yellow'>$&</u>`);
    }
    return htxt;
  };

  return orgProgs.length ? (
    <div className={`lsn-programs-wrapper ${isShowMore ? 'showing-more' : 'showing-less'}`}>
      <div className={'lsn-programs-label c-hand'} onClick={handleShowMore} onKeyPress={handleShowMore}>
        <i
          className={'fa ' + (isShowMore ? 'fa-chevron-down' : 'fa-chevron-right')}
          aria-label="Show more Programs"
          aria-expanded={isShowMore}
          role="button"
          tabIndex={0}
        ></i>
        <TextBody bold>
          Programs:
          <TextBadge className="ml-2">{orgProgs.flatMap(item => item[1].split('|')).length}</TextBadge>
        </TextBody>
      </div>
      <ul aria-live="polite" className="lsn-programs-list" hidden={!isShowMore}>
        {orgProgs.map(([organization, programs], key) => (
          <li key={key}>
            <span
              className="organization-name"
              dangerouslySetInnerHTML={{
                __html: getHighlightedStr(`${organization} - `, highlightWords),
              }}
            ></span>
            <ul>
              {programs.split('|').map((program, key) => (
                <li
                  key={key}
                  dangerouslySetInnerHTML={{
                    __html: getHighlightedStr(program.trim(), highlightWords),
                  }}
                ></li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
    </div>
  ) : null;
};

export default ProgramList;
